import { BaseEntity } from "yt-ng-framework";
import { Language } from "src/app/lookups/language/Language";
import { UserRole } from "../userrole/userrole";

export class User extends BaseEntity{
    constructor(){
        super();
    }

    CompanyID: number = null;
    Email: string = null;
    FirstName: string = null;
    LastName: string = null;
    UserName: string = null;
    Password: string = null;
    //ConfirmPassword: string = null;
    RoleID: number = null;
    LanguageID: number = null;
    OrgJedID: number = null;
    IPAddress: string = null;
    is_active: boolean = false;
    PhoneNumber:string=null;

    Deserialize(input: any){
        // super.Deserialize(input);
        this.ID = input.ID;
        this.CompanyID = input.CompanyID;
        this.Email = input.Email;
        this.FirstName = input.FirstName;
        this.LastName = input.LastName;
        this.UserName = input.UserName;
        this.Password = input.Password;
        //this.ConfirmPassword = input.ConfirmPassword;
        this.RoleID = input.RoleID;
        this.LanguageID = input.LanguageID;
        this.OrgJedID = input.OrgJedID;
        this.IPAddress = input.IPAddress;
        this.is_active = input.is_active;
        this.PhoneNumber=input.PhoneNumber;
        return this;
    }


    Serialize(input: User){
        return input;
    }
}